module.exports = __webpack_public_path__ + "img/register.4907946c.png";